import api from 'Application/api/api';

const createGroupInstructionAssignment = (data, cancelToken = null) =>
    api.post('education/instruction-assignments/group', data, { cancelToken });

export default createGroupInstructionAssignment;
